var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1131.37 190.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #cccbca;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 126.22,
    width: 17.81,
    height: 190.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 319.44,
    width: 17.42,
    height: 190.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 486.31,
    width: 17.42,
    height: 190.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 652.81,
    width: 17.41,
    height: 190.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 810.78,
    width: 17.42,
    height: 190.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 998.56,
    width: 17.42,
    height: 190.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.63,36.01c10.45,0,18.58,2.33,24.4,5.03l6.19-23.23c-5.03-2.7-16.65-5.42-31.75-5.42C31.36,12.39,0,36.4,0,80.54c0,36.79,23.23,64.66,67.76,64.66,15.49,0,27.49-3.1,32.91-5.43l-4.26-22.84c-6.2,2.32-15.49,4.26-24.39,4.26-25.94,0-41.43-16.27-41.43-42.2,0-29.05,18.19-42.98,41.04-42.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232.7,12.39h-1.16c-37.17.39-61.56,29.04-61.56,67.38s22.46,65.44,60.4,65.44h1.16c37.18-.39,62.34-25.56,62.34-67.76,0-35.62-21.68-65.05-61.17-65.05M231.93,121.97h-.39c-19.36,0-30.97-18.58-30.97-42.97s11.23-43.38,30.97-43.76h.39c19.75,0,30.98,20.14,30.98,42.98,0,25.56-11.62,43.75-30.98,43.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M447.59,24.01c-7.35-6.2-18.2-9.69-32.52-10.45h-6.97c-17.82,0-30.21,1.16-39.49,2.7v127h29.04v-46.47c2.7.78,6.19.78,10.07.78h7.35c13.93-1.17,25.94-5.81,34.46-13.55,7.74-6.97,11.61-17.81,11.61-30.59s-5.42-23.24-13.55-29.43M415.07,74.73c-2.33.39-5.03.77-7.74.77-4.26,0-7.36-.39-9.68-.77v-38.33c1.94-.39,6.19-.78,11.99-.78,1.95,0,3.88,0,5.43.39,11.23,1.54,17.42,8.13,17.42,18.58s-6.58,17.81-17.42,20.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M614.08,24.01c-7.35-6.2-18.2-9.69-32.52-10.45h-6.97c-17.81,0-29.81,1.16-39.11,2.7v127h28.66v-46.47c2.71.78,6.19.78,10.07.78h7.35c13.93-1.17,25.94-5.81,34.46-13.55,7.74-6.97,11.62-17.81,11.62-30.59s-5.03-23.24-13.56-29.43M581.56,74.73c-2.32.39-5.04.77-7.74.77-4.26,0-7.35-.39-9.68-.77v-38.33c1.94-.39,6.19-.78,12.01-.78,1.94,0,3.87,0,5.42.39,11.23,1.54,17.43,8.13,17.43,18.58s-6.6,17.81-17.43,20.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "731.4 88.67 757.73 88.67 757.73 65.05 731.4 65.05 731.4 38.34 781.73 38.34 781.73 14.33 702.37 14.33 702.37 143.27 784.45 143.27 784.45 119.26 731.4 119.26 731.4 88.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M940.1,51.89c0,19.36.39,36.78,2.33,53.82h-.39c-6.2-14.32-13.55-30.59-21.3-44.14l-26.72-47.24h-33.68v128.94h26.71v-38.72c0-21.3-.38-39.49-1.54-56.53h.78c6.19,15.1,14.72,31.36,22.45,45.3l27.49,49.95h30.59V14.33h-26.71v37.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1098.07,66.6c-17.03-6.19-24-10.07-24-18.2,0-6.58,6.19-12.38,18.97-12.38s21.68,3.48,26.72,6.2l6.19-23.63c-7.36-3.48-17.81-6.19-32.52-6.19-30.21,0-48.78,16.65-48.78,38.33,0,18.97,13.93,30.98,35.62,38.73,15.1,5.03,21.3,10.07,21.3,17.81,0,8.52-6.97,14.32-20.52,14.32-12.39,0-24.39-4.26-32.14-8.13l-5.81,23.62c7.36,4.26,21.68,8.13,36.4,8.13,35.24,0,51.89-18.2,51.89-39.88,0-18.2-10.46-30.2-33.3-38.72"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooter);
export default __webpack_public_path__ + "static/media/logoFooter.b65436e1ce031696418961224edea256.svg";
export { ForwardRef as ReactComponent };